// Google Sheets Integration
// This file handles sending form data to Google Sheets

export interface FormSubmission {
  name: string
  phone: string
  email: string
  message: string
  type: string // סוג הטופס (צור קשר, הרשמה וכו')
  source?: string // מאיזה דף נשלחה הפנייה (דף הבית, SUP, Wing Foil וכו')
  timestamp?: string
  orderNumber?: string // מספר הזמנה ייחודי
}

export async function sendToGoogleSheets(
  data: FormSubmission,
): Promise<boolean> {
  // Google Apps Script URL - מחובר ל-Sheet ושולח מיילים אוטומטית
  const SCRIPT_URL =
    'https://script.google.com/macros/s/AKfycbyx2nT7GUZHPL7eXtRwIBLHjW5AYm4GY5H1CCC8TK3RAYjCZyF-NdhN8tUAdsR70Ub5CA/exec'

  try {
    const submissionData = {
      ...data,
      timestamp: new Date().toISOString(),
    }

    const response = await fetch(SCRIPT_URL, {
      method: 'POST',
      mode: 'no-cors', // חשוב! Google Apps Script דורש זאת
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(submissionData),
    })

    // בגלל no-cors, לא נוכל לקרוא את התגובה
    // אבל אם לא היה error, זה אומר שהשליחה הצליחה
    return true
  } catch (error) {
    console.error('Error sending to Google Sheets:', error)
    return false
  }
}

// פונקציה לשליחה גם למייל וגם ל-Sheets
export async function submitForm(data: FormSubmission): Promise<{
  success: boolean
  message: string
}> {
  try {
    // שליחה ל-Google Sheets (גם שומר ב-Sheet וגם שולח מייל אוטומטית)
    const sheetsSuccess = await sendToGoogleSheets(data)

    if (sheetsSuccess) {
      return {
        success: true,
        message: 'הפנייה נשלחה בהצלחה!',
      }
    } else {
      return {
        success: false,
        message: 'אירעה שגיאה בשליחת הפנייה. אנא נסה שוב.',
      }
    }
  } catch (error) {
    console.error('Form submission error:', error)
    return {
      success: false,
      message: 'אירעה שגיאה בשליחת הפנייה. אנא נסה שוב.',
    }
  }
}
